// localStorageUtil.js

const STORAGE_KEY = 'userData';

export const setLocalStorageData = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getLocalStorageData = () => {
  const storedData = localStorage.getItem(STORAGE_KEY);
  return storedData ? JSON.parse(storedData) : null;
};

export const clearLocalStorage = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const setLogoutTimer = (callback, timeout) => {
  return setTimeout(() => {
    callback();
  }, timeout);
};
